<template>
    <svg aria-hidden="true" viewBox="0 0 12.25 18.5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.125 0.5C6.47018 0.5 6.75 0.779822 6.75 1.125V15.8661L10.6831 11.9331C10.9271 11.689 11.3229 11.689 11.5669 11.9331C11.811 12.1771 11.811 12.5729 11.5669 12.8169L6.56694 17.8169C6.32287 18.061 5.92714 18.061 5.68306 17.8169L0.683058 12.8169C0.438981 12.5729 0.438981 12.1771 0.683058 11.9331C0.927136 11.689 1.32287 11.689 1.56694 11.9331L5.5 15.8661V1.125C5.5 0.779822 5.77982 0.5 6.125 0.5Z"
            fill="currentColor" />
    </svg>
</template>
